import { Menu, Phone, Scale, X } from 'lucide-react'
import { type MouseEvent, useEffect, useState } from 'react'

const phoneDisplay = '214-754-5500'
const phoneHref = 'tel:+12147545500'

const navigation = [
  { href: '/', label: 'Home' },
  { href: '/commercial-litigation', label: 'Commercial Litigation' },
  { href: '/personal-injury-litigation', label: 'Personal Injury' },
  { href: '/real-estate', label: 'Real Estate' },
  { href: '/attorney', label: 'Attorney' },
  { href: '/#contact', label: 'Contact' },
]

function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false)
  const currentPath = window.location.pathname.replace(/\/+$/, '') || '/'

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : ''

    const closeOnEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') setMenuOpen(false)
    }

    window.addEventListener('keydown', closeOnEscape)
    return () => {
      document.body.style.overflow = ''
      window.removeEventListener('keydown', closeOnEscape)
    }
  }, [menuOpen])

  const closeMenu = () => setMenuOpen(false)

  const handleNavigation = (event: MouseEvent<HTMLAnchorElement>, href: string) => {
    closeMenu()

    if (href !== '/#contact' || currentPath !== '/') return

    event.preventDefault()
    if (window.location.hash !== '#contact') {
      window.history.pushState(null, '', '/#contact')
    }
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }

  return (
    <header className="site-header is-scrolled">
      <div className="header-inner container">
        <a className="brand" href="/" onClick={closeMenu}>
          <span className="brand-mark" aria-hidden="true">
            <Scale size={25} strokeWidth={1.7} />
          </span>
          <span className="brand-type">
            <strong>Buchholz Law</strong>
            <small>Dallas, Texas</small>
          </span>
        </a>

        <button
          className="menu-toggle"
          type="button"
          aria-expanded={menuOpen}
          aria-controls="primary-navigation"
          aria-label={menuOpen ? 'Close navigation' : 'Open navigation'}
          onClick={() => setMenuOpen((open) => !open)}
        >
          {menuOpen ? <X /> : <Menu />}
        </button>

        <nav
          id="primary-navigation"
          className={`primary-nav ${menuOpen ? 'is-open' : ''}`}
          aria-label="Primary navigation"
        >
          {navigation.map(({ href, label }) => {
            const pagePath = href.split('#')[0] || '/'
            const isCurrent = label !== 'Contact' && currentPath === pagePath

            return (
              <a
                href={href}
                onClick={(event) => handleNavigation(event, href)}
                aria-current={isCurrent ? 'page' : undefined}
                key={href}
              >
                {label}
              </a>
            )
          })}
          <a className="nav-call" href={phoneHref} onClick={closeMenu}>
            <Phone size={16} aria-hidden="true" />
            {phoneDisplay}
          </a>
        </nav>
      </div>
    </header>
  )
}

export default SiteHeader
